<div class="dynamic-date-time-range-type">
  @if (!props.disabled) {
    <div class="dynamic-date-time-range-type-input" (click)="toggle($event)">
      <span class="input-value">
        @let dateFrom = formControl.value?.date?.[0];
        @let dateTo = formControl.value?.date?.[1];

        @if (dateFrom || dateTo) {
          @let date = formControl.value.date;
          @let fromTime = formControl.value.from;
          @let toTime = formControl.value.to;

          @if (date.length) {
            @if (date[0]) {
              {{ date[0] | date: 'dd-MM-yyyy' }} {{ formControl.value.from }}
            }

            @if (date[0] && date[1]) {
              &nbsp;<i class="mynaui-arrow-right" aria-hidden="true"></i>&nbsp;
            }

            @if (date[1]) {
              {{ date[1] | date: 'dd-MM-yyyy' }} {{ formControl.value.to }}
            }
          }

          <small class="info">({{ 'flow.tab.log.time_zone.local.label' | translate }})</small>
        } @else {
          {{ props.placeholder }}
        }
      </span>
    </div>
  }
</div>

<p-popover #dateTimeRangePicker [appendTo]="'body'" [styleClass]="'date-time-range-type-popover-wrapper'">
  <div class="date-time-range-type-popover" [formGroup]="formGroup">
    <div class="date-picker">
      <p-date-picker
        [inline]="true"
        formControlName="date"
        [selectionMode]="props.selectionMode || 'range'"
        [maxDate]="maxDate()"
        [minDate]="props.minDate"
        (onSelect)="onDateSelect($event)" />
    </div>
    <div class="time-picker">
      <div class="time-picker-box from-time">
        <p-date-picker [timeOnly]="true" formControlName="from" (onBlur)="checkFromToTime('from')" />
      </div>
      <div class="separator">
        <i class="mynaui-arrow-right" aria-hidden="true"></i>
      </div>
      <div class="time-picker-box to-time">
        <p-date-picker [timeOnly]="true" formControlName="to" (onBlur)="checkFromToTime('to')" />
      </div>

      <i class="clickable mynaui-undo reset-time" (click)="resetTime()"></i>
    </div>

    <div class="actions">
      <cap-button styleClass="primary btn-sm" [label]="'apply.button' | translate" (onClick)="apply()" />
    </div>
  </div>
</p-popover>
